import { useEffect, useMemo, useState } from 'react';

import api from '../../../utils/api';
import { API_ENDPOINTS } from '../../../constants';

const normaliseEventsPayload = (eventsResponse) => {
  const payload = eventsResponse?.data ?? eventsResponse;
  if (Array.isArray(payload)) {
    return payload;
  }
  if (Array.isArray(payload?.results)) {
    return payload.results;
  }
  if (Array.isArray(payload?.data)) {
    return payload.data;
  }
  return [];
};

export const useDashboardData = () => {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);
  const [fallEvents, setFallEvents] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    const loadDashboard = async () => {
      setLoading(true);
      setError('');

      try {
        const [statsResponse, eventsResponse] = await Promise.all([
          api.get(API_ENDPOINTS.ADMIN.DASHBOARD),
          api.get(API_ENDPOINTS.FALL_EVENTS.ROOT, { params: { page_size: 100 } }),
        ]);

        if (!active) {
          return;
        }

        const statsPayload = statsResponse?.data ?? statsResponse;
        setStats(statsPayload ?? null);
        setFallEvents(normaliseEventsPayload(eventsResponse));
      } catch (err) {
        if (!active) {
          return;
        }
        console.error('Failed to load admin dashboard', err);
        setError('Unable to load dashboard data right now. Please try again shortly.');
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    loadDashboard();

    return () => {
      active = false;
    };
  }, []);

  const latestEvents = useMemo(() => fallEvents.slice(0, 6), [fallEvents]);

  return {
    loading,
    error,
    stats,
    fallEvents,
    latestEvents,
  };
};
